import { render } from "./COICoreTable.vue?vue&type=template&id=1abb5f61&scoped=true"
import script from "./COICoreTable.vue?vue&type=script&lang=js"
export * from "./COICoreTable.vue?vue&type=script&lang=js"

import "./COICoreTable.vue?vue&type=style&index=0&id=1abb5f61&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abb5f61"]])

export default __exports__